import { ContactListItem, Scope, SelectionItem } from '@utils'
import { Dayjs } from 'dayjs'

export interface KeepContact {
  id: string
  name: string
  contact: ContactListItem
  date: string
  repeatUnit: SelectionItem
  repeatWeek?: SelectionItem
  repeatFrequency?: number
  repeatMonth?: number[]
  scope: Scope
}

export function matchesRepeatMonth(date: Dayjs, repeatDays: number[]) {
  const dayOfMonth = date.date();
  const isLastDay = date.date() === date.daysInMonth();
  return repeatDays.some(day => {
    return (day === 32 && isLastDay) || day === dayOfMonth;
  });
}

export const useKeepContactStore = () => {
  return {
    weekDays: [{id: '1', name: 'Lundi'}, {id: '2', name: 'Mardi'}, {id: '3', name: 'Mercredi'}, {id: '4', name: 'Jeudi'}, {id: '5', name: 'Vendredi'}, {id: '6', name: 'Samedi'}, {id: '0', name: 'Dimanche'}],
    repeatUnits: [{id: 'day', name: 'Tous les jours'}, {id: 'week', name: 'Toutes les semaines'}, {id: 'month', name: 'Tous les mois'}, {id: 'year', name: 'Tous les ans'}],
  }
}